// extracted by mini-css-extract-plugin
export default {"quotes":"ViewQuotesPage_quotes__8GoQN","main":"ViewQuotesPage_main__YfZ6R"};